import styled from '@emotion/styled';
import { ISupporterChatRoom } from 'domain/entities/ChatRoom/SupporterChatRoom';
import { UserIcon } from 'ui/components/elements/UserIcon/UserIcon';
import dayjs from 'dayjs';

const Wrapper = styled.div<{ selected: boolean }>`
    display: flex;
    flex-direction: column;
    gap: 10px;
    border-radius: 4px;
    padding: 10px;
    cursor: pointer;
    box-shadow: 2px 2px 4px 0px #0000001a;
    position: relative;
    border: ${({ selected }) => (selected ? '1px solid var(--main-color-blue)' : 'none')};
    background: var(--white);
`;

const CompanyNameContainer = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
    font-weight: var(--font-bold);
`;

const DateContainer = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
    font-size: var(--font-small);
`;

const MessageContainer = styled.div`
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
`;

const Label = styled.div<{ color?: string }>`
    font-size: var(--font-small);
    color: var(--white);
    white-space: nowrap;
    background: ${({ color }) => (color ? color : 'var(--main-color-blue)')};
    padding: 5px 8px;
    border-radius: 10px;
    width: fit-content;
    font-weight: var(--font-bold);
`;

const Labels = styled.div`
    display: flex;
    gap: 6px;
`;

const NewLabel = styled.div`
    position: absolute;
    bottom: 8px;
    right: 8px;
    font-size: var(--font-small);
    color: var(--white);
    background-color: red;
    padding: 3px 6px;
    border-radius: 10px;
    font-weight: var(--font-bold);
`;

export const SupporterChatRoomItem: React.FC<{
    chatRoom: ISupporterChatRoom;
    selected: boolean;
    unread: boolean;
    onClick: () => void;
}> = ({ chatRoom, unread, selected, onClick }) => {
    const noMessage = chatRoom.last_message_sent_at === null;
    const company = chatRoom.company || chatRoom.buyer;
    const isCompany = !!chatRoom.company;

    if (!company) {
        return null;
    }

    return (
        <Wrapper selected={selected} onClick={onClick}>
            <Labels>
                {isCompany && <Label color="var(--main-color-blue)">売り手</Label>}
                {!isCompany && <Label color="var(--primary)">買い手</Label>}
            </Labels>
            <CompanyNameContainer>
                <UserIcon size={30} src={company.icon_image} />
                <span>{company.name}</span>
            </CompanyNameContainer>
            <DateContainer>
                {noMessage ? (
                    <span>チャット開始日：-</span>
                ) : (
                    <span>{dayjs(chatRoom.last_message_sent_at).format('YYYY/MM/DD HH:mm')}</span>
                )}
            </DateContainer>
            <MessageContainer>
                {noMessage ? <span>まだメッセージがありません</span> : <span>{chatRoom.last_message_text || ''}</span>}
            </MessageContainer>
            {unread && <NewLabel>NEW</NewLabel>}
        </Wrapper>
    );
};
